import isString from 'lodash/isString';
import classNames from 'classnames';

import styles from './SelectListNew.module.scss';

import { MeatballButtonMenuItem } from '@components/ActionButtons/MeatballButton';
import { SelectListItem } from '@components/SelectListNew/components/SelectListItem';

interface Props {
    items: MeatballButtonMenuItem[];
    hasSelected?: boolean;
    maxWidth?: number;
    onClose(): void;
    onItemClick?(id: string): void | Promise<void>;
}

export function SelectListNew({ items, onClose, hasSelected, onItemClick, maxWidth }: Props) {
    return (
        <div
            className={classNames([styles.root, hasSelected && styles.hasSelected])}
            style={{ maxWidth }}
        >
            {items.map((item, index) =>
                'divider' in item ? (
                    <div
                        key={`divider_${index}`}
                        className={styles.divider}
                    />
                ) : (
                    <SelectListItem
                        maxWidth={maxWidth}
                        key={item.value ? item.value : isString(item.label) ? item.label : index}
                        item={item}
                        onItemClick={onItemClick}
                        onClose={onClose}
                    />
                ),
            )}
        </div>
    );
}
